import React, { Component } from 'react';
import { Row, Col, Card, CardBody, FormGroup, Button,  Label, Spinner, Modal, ModalHeader, ModalBody, } from "reactstrap";
import { AvForm, AvField} from "availity-reactstrap-validation";
import { Link } from "react-router-dom"
import "react-datepicker/dist/react-datepicker.css";
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
import Select from "react-select";
import SweetAlert from "react-bootstrap-sweetalert";
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";
import { BaseUrl } from "../../helpers/Baseurl"
import { get } from '../../helpers/api_helper'


class VehicleDetail extends Component {
    constructor(props) {
        super(props);
        this.obj = this.props.obj

        this.state = {
            vehicle_success_confirm: false,
            vehicle_alert_confirm : false,
            dynamic_title: "",
			dynamic_description: "",
            addVehicleloading:false,
            editVehicleloading:false,
            itinerary : this.props.data,
            DestinationGroup:[],
            vehicle_id : "",
            itineraryVehicles:[],
            VehicleTypeGroup:[],
            
            VehicleLocationsGroup:[],
            selectedVehicleType: { label: "Select Vehicle Type", value: null },
            selectedVehicle: { label: "Select Vehicle", value: null },
            SelectedDuration:{ label: "Select Duration", value: null },
            selectedDestination:{ label: "Select Destination", value: null },
            selectedLocation: { label: "Select Location", value: null },
            vehiclesGroup:[],
            vehiclePricing:[],
            VehicleDurationGroup:[],
            // Hotel Edit 
            selected_vehicle:{}

            
        }

        toastr.options = {
            positionClass: "toast-top-right",
            closeButton: "false",
            progressBar: "true",
            showEasing: "swing",
            hideEasing: "linear",
            showMethod: "fadeIn",
            hideMethod: "fadeOut",
            showDuration: 300,
            hideDuration: 1000,
            timeOut: 5000,
            extendedTimeOut: 1000
            }

        // this.onDestinationInputChange = this.onDestinationInputChange.bind(this)
        this.onInputChange = this.onInputChange.bind(this)
        this.onVehicleInputChange = this.onVehicleInputChange.bind(this)
        this.clearStateData = this.clearStateData.bind(this); 
        this.tog_addVehicle = this.tog_addVehicle.bind(this); 
        this.handleVehicleDelete = this.handleVehicleDelete.bind(this); 
        this.handleSaveVehicle = this.handleSaveVehicle.bind(this); 
        this.handleEditVehicleSubmit = this.handleEditVehicleSubmit.bind(this);
        this.tog_editVehicle = this.tog_editVehicle.bind(this);
    }  

    clearStateData(){
        
        let addVehicleloading = false
        let editVehicleloading = false
        let vehicle_id  =  ""
    
        let selectedVehicleType = { label: "Select Vehicle Type", value: null }
        let selectedVehicle =  { label: "Select Vehicle", value: null }
        let SelectedDuration ={ label: "Select Duration", value: null }
        let vehiclesGroup = []
        let vehiclePricing = []
        let VehicleDurationGroup = []
        this.setState({ addVehicleloading, editVehicleloading, vehicle_id, 
                        selectedVehicleType, selectedVehicle, vehiclePricing,
                        vehiclesGroup, VehicleDurationGroup, SelectedDuration
            })
    }

    tog_addVehicle() {
        this.clearStateData()
        this.setState(prevState => ({
            model_addVehicle: !prevState.model_addVehicle
        }));
        this.removeBodyCss();
    }

    tog_editVehicle() {
        this.setState(prevState => ({
            model_editVehicle: !prevState.model_editVehicle
        }));
        this.removeBodyCss();
    }

    removeBodyCss() {
        document.body.classList.add("no_padding");
    }

    componentDidCatch(error) {
        console.log(error)
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.data !== this.props.data) {
            const itinerary = this.props.data
            this.setState({itinerary: itinerary})
        }
        if(prevProps.data.destinations !== this.props.data.destinations){
            this.loadItineraryDestinarion()
        }
      }

    async componentDidMount() {    
        await this.loadVehicleTypeData()
        await this.loadItineraryVehicles()
        this.loadItineraryDestinarion()
    }

    async loadDestinationPlaces(filer_queryset){
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json','Authorization': `Bearer ${this.obj.access}`  },
          };
          await fetch(`${BaseUrl}/api/locations/location/locations/${filer_queryset}`,requestOptions)
              .then(res => res.json())
              .then(
                  (data) => {
                      
                      if (data.results){
                        let options = []
                        data.results.map(destination => {
                            options.push({ label: destination.name, value: destination.id })
                          })
                       
                          let VehicleLocationsGroup = [
                              { 
                                  label: "Places",
                                  options: options
                              }
                          ]
                          this.setState({ VehicleLocationsGroup }) 
                      }
                         
                     
                  },
                  (error) => {
                      console.log(error, 'error--------------') 
                  }
              ) 
    }
    
    async loadItineraryVehicles(){
        const { itinerary } = this.state
        const requestOptions = {
          
            headers: { 'Content-Type': 'application/json','Authorization': `Bearer ${this.obj.access}`  },
        };
        await get(`${BaseUrl}/api/itineraries/itinerary-vehicles/?itinerary__id=${itinerary.id}`, requestOptions )
        .then(response => {
            let total = 0 
                    for(let i=0; i< response.length; i++){
                        total = total + parseInt(response[i].margin_price)
                    }
                    this.props.handleVehicleTotal(total)               
                    this.setState({ itineraryVehicles: response }) 
                    this.clearStateData()   
        })
        // await fetch(`${BaseUrl}/api/itineraries/itinerary-vehicles/?itinerary__id=${itinerary.id}`,requestOptions)
        //     .then(res => res.json())
        //     .then(
        //         (data) => { 
        //             let total = 0 
        //             for(let i=0; i< data.length; i++){
        //                 total = total + parseInt(data[i].margin_price)
        //             }
        //             this.props.handleVehicleTotal(total)               
        //             this.setState({ itineraryVehicles: data }) 
        //             this.clearStateData()          
                    
        //         },
        //         (error) => {
        //             console.log(error, 'error--------------') 
        //         }
        //     )  
    }

    async loadVehicleTypeData(){

        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json','Authorization': `Bearer ${this.obj.access}`  },
        };
        await fetch(`${BaseUrl}/api/vehicles/vehicle_type/`,requestOptions)
        .then(res => res.json())
        .then(
            (data) => {
                let options = []
                data.map(comp => {
                    options.push({ label: comp.name, value: comp.id })
                })
                
                let VehicleTypeGroup = [
                    { 
                    label: "Vehical Type",
                    options: options
                    }
                ];
                this.setState({ VehicleTypeGroup: VehicleTypeGroup })           
                
            },
            (error) => {
                console.log(error, 'error--------------') 
            }
        )  
    }
    
    async loadVehicleByTypeData(filter_data ){
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json','Authorization': `Bearer ${this.obj.access}`  },
        };
        await fetch(`${BaseUrl}/api/vehicles/vehicle/${filter_data}`,requestOptions)
        .then(res => res.json())
        .then(
            (data) => {
            let options = []
            data.results.map(vehicle => {
                options.push({ label: vehicle.name, value: vehicle.id })
                })
            
                let vehiclesGroup = [
                { 
                    label: "Vehicles",
                    options: options
                }
            ];
            this.setState({ vehiclesGroup:vehiclesGroup }) 
            },
            (error) => {
                console.log(error, 'error--------------') 
            }
        )

          
    }
    
    async loadVehicleData(id){
        const requestOptions = {
          method: 'GET',
          headers: { 'Content-Type': 'application/json','Authorization': `Bearer ${this.obj.access}`  },
        };
        await fetch(`${BaseUrl}/api/vehicles/vehicle/${id}/`,requestOptions)
            .then(res => res.json())
            .then(
                (data) => {
                    let options = []
                    data.pricing.map(pricing => {
                        let lable = pricing.package.nights === 0 ? `${pricing.package.days} Day` : `${pricing.package.days} Days - ${pricing.package.nights} Nights`
                        options.push({ label: lable, value: pricing.id })
                    })
                    let VehicleDurationGroup = [
                        { 
                        label: "Durations",
                        options: options
                        }
                    ];
                    this.setState({ VehicleDurationGroup: VehicleDurationGroup, vehiclePricing:data.pricing, vehicleSeasons:data.seasons }) 
                   
                },
                (error) => {
                    console.log(error, 'error--------------') 
                }
            ) 
    }

    // onDestinationInputChange(e){
    //     const requestOptions = {
    //         method: 'GET',
    //         headers: { 'Content-Type': 'application/json','Authorization': `Bearer ${this.obj.access}`  },
    //       };
    //         fetch(`${BaseUrl}/api/locations/location/locations/?parent=null&search=${e}`,requestOptions)
    //           .then(res => res.json())
    //           .then(
    //               (data) => {
    //                   let options = []
    //                   data.results.map(destination => {
    //                       options.push({ label: destination.name, value: destination.id })
    //                     })
                     
    //                     let DestinationGroup = [
    //                       { 
    //                           label: "Destination",
    //                           options: options
    //                       }
    //                   ];
    //                   this.setState({ DestinationGroup:DestinationGroup  })      
                     
    //               },
    //               (error) => {
    //                   console.log(error, 'error--------------') 
    //               }
    //           )  
    // }

    // load Destinations added in itinerary 
    loadItineraryDestinarion(){
        let destinations = this.props.data.destinations

            let options = []
            destinations.map(destination => {
                options.push({ label: destination.name, value: destination.id })
                })    
            let DestinationGroup = [
                { 
                    label: "Destinations",
                    options: options
                }
            ]
            this.setState({ DestinationGroup })

    }

    onInputChange(e){
        const { selectedDestination } = this.state
        this.loadDestinationPlaces(`?parent__id=${selectedDestination.value}&search=${e}`)
    }

    onVehicleInputChange(e){
        const { selectedVehicleType } = this.state
        if(selectedVehicleType.value)
        this.loadVehicleByTypeData(`?vehicle_type__id=${selectedVehicleType.value}&search=${e}`)
    }
    
    handleSelectLocationGroup = selectedLocation =>{ 
    this.setState({ selectedLocation })
    }   

    handleselectedVehicleType = selectedVehicleType =>{
        this.clearStateData()
        this.loadVehicleByTypeData(`?vehicle_type__id=${selectedVehicleType.value}`)
        
        this.setState({ selectedVehicleType })
    }

    handleselectedVehicle = selectedVehicle =>{
        let vehiclePricing = []
        let VehicleDurationGroup = []
        let SelectedDuration ={ label: "Select Duration", value: null }
        this.loadVehicleData(selectedVehicle.value)
        this.setState({ selectedVehicle, SelectedDuration,vehiclePricing, VehicleDurationGroup })
    }

    handleselectedDuration = SelectedDuration =>{
        this.setState({ SelectedDuration })
    }

    handleSelectedDestination = selectedDestination =>{
        
        let selectedLocation = { label: "Select Location", value: null }
        this.loadDestinationPlaces(`?parent__id=${selectedDestination.value}`)
        this.setState({ selectedDestination, selectedLocation })
    }   

    handleVehicleDelete = (id) =>{
        console.log(id)
        const requestOptions = {
            method: 'DELETE',
            headers: { 'Authorization': `Bearer ${this.obj.access}`  },
        
            };
              fetch(`${BaseUrl}/api/itineraries/itinerary-vehicles/${id}/`,requestOptions)
                    .then(res => 
                        {if(res.status >= 400){
                          console.log("error")
                        }
                        else{
                          this.loadItineraryVehicles()
                          this.setState({
                            vehicle_id:"",
                            vehicle_success_confirm: true,
                            vehicle_alert_confirm : false,
                            dynamic_title: "Deleted!",
                            dynamic_description: "Vehicle has been deleted."
                            })
                        }
                    }
                )
    }

    handleVehicleEdit = (row) =>{
        let selectedDestination = { label: row.pick_up_location.parent.name, value: row.pick_up_location.parent.id }
        let selectedLocation = { label: row.pick_up_location.name, value: row.pick_up_location.id }
        let selectedVehicleType = { label: row.vehicle.vehicle_type.name, value: row.vehicle.vehicle_type.id }
        let selectedVehicle = { label: row.vehicle.name, value: row.vehicle.id }
        let lable = row.packege.package.nights === 0 ? `${row.packege.package.days} Day` : `${row.packege.package.days} Days - ${row.packege.package.nights} Nights`
        let SelectedDuration= { label: lable, value: row.packege.id }
        
        this.setState({ selected_vehicle:row, selectedLocation,selectedVehicleType,SelectedDuration,
                        selectedVehicle,selectedDestination,})
        this.tog_editVehicle()
        this.loadDestinationPlaces(`?parent__id=${selectedDestination.value}`)
        this.loadVehicleData(selectedVehicle.value)
        this.loadVehicleByTypeData(`?vehicle_type__id=${selectedVehicleType.value}`) 
    }

    isInclude(string, array){
        let new_string = string.toLowerCase()
        let data = new_string.split(" ")
        for( let i=0; i<data.length; i++){  
            if (array.includes(data[i])){
                return true
            }
        }
        return false
    }

    handleEditVehicleSubmit(e, values){

        const { itinerary, vehiclePricing, selectedVehicle, selected_vehicle, SelectedDuration,vehicleSeasons, selectedLocation }  = this.state
        let selected_price = null
        let startDate = new Date(itinerary.start_date)
        let endDate =  new Date(itinerary.end_date)
        let on_season = false
        if (selectedLocation.value === null){
            toastr.error(`Please Select Pickup Location`, "")
        }
        if(SelectedDuration.value === null){
            toastr.error(`Please Select Vehicle Duration`, "")
        }
        else{

            for(let i=0; i<vehiclePricing.length; i++){
                if(SelectedDuration.value === vehiclePricing[i].id){
                    selected_price = vehiclePricing[i]
                }
            }
            if (!selected_price){
                this.setState({SelectedDuration:{ label: "Select Duration", value: null }})
                toastr.error(`Please Select Vehicle Duration`, "")
            }else{
                // Check plan date is season date or not 
            for(let j=0; j<vehicleSeasons.length; j++){
                let start_date = vehicleSeasons[j].start_date
                let start_month = vehicleSeasons[j].start_month
                let end_date = vehicleSeasons[j].end_date
                let end_month = vehicleSeasons[j].end_month
                let seasonStartDate = new Date(start_month+"-"+start_date+"-"+startDate.getFullYear());
                let seasonEndDate = new Date(end_month+"-"+end_date+"-"+startDate.getFullYear()+1);
                if (end_month<start_month){
                    seasonEndDate = new Date(end_month+"-"+end_date+"-"+startDate.getFullYear()+1);
                }else{
                    seasonEndDate = new Date(end_month+"-"+end_date+"-"+startDate.getFullYear());
                }
                if (((startDate >= seasonStartDate && startDate <= seasonEndDate))|| (endDate >= seasonStartDate && endDate <= seasonEndDate)) {
                    on_season = true
                    break;
                }
            }

            let price = 0
            price = on_season?parseInt(selected_price.on_season_price)*parseInt(values.number_of_days):parseInt(selected_price.price)*parseInt(values.number_of_days)

            let data = {}
            data['days'] = values.number_of_days
            data['pick_up_location'] = selectedLocation.value
            data["itinerary"] = itinerary.id
            data["vehicle"] = selectedVehicle.value
            data["packege"] = selected_price.id
            data["margin_price"] = price

        const requestOptions = {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json','Authorization': `Bearer ${this.obj.access}`  },
            body: JSON.stringify(data)
            };
            fetch(`${BaseUrl}/api/itineraries/itinerary-vehicles/${selected_vehicle.id}/`,requestOptions)
                  .then(res => 
                      {if(res.status >= 400){
                          res.json()
                          .then(
                              (data) =>{  
                                  console.log(data, "-error")
                                toastr.error("Something Went Wrong", "") 
                                this.setState({ editVehicleloading: false })
                              }
                                
                          )
                      }
                      else{
                          res.json()
                          .then(
                                (data) =>{
                                toastr.success(`${data.vehicle.name} Edited Successfully`, "") 
                                this.setState({ model_editVehicle:false })
                                this.loadItineraryVehicles()
                              }
                          )
                      }    
                  }
              )
                
            }
            
        }

    }

    handleSaveVehicle(e, values){
        const { itinerary, vehiclePricing, selectedVehicle, vehicleSeasons, SelectedDuration, selectedLocation }  = this.state
        let selected_price = null
        let startDate = new Date(itinerary.start_date)
        let endDate =  new Date(itinerary.end_date)
        let on_season = false
        if (selectedLocation.value === null){
            toastr.error(`Please Select Pickup Location`, "")
        }
        else if(SelectedDuration.value === null){
            toastr.error(`Please Select Vehicle Duration`, "")
        }
        else{

            for(let i=0; i<vehiclePricing.length; i++){
                if(SelectedDuration.value === vehiclePricing[i].id){
                    selected_price = vehiclePricing[i]
                }
            }
            // Check plan date is season date or not 
            for(let j=0; j<vehicleSeasons.length; j++){
                let start_date = vehicleSeasons[j].start_date
                let start_month = vehicleSeasons[j].start_month
                let end_date = vehicleSeasons[j].end_date
                let end_month = vehicleSeasons[j].end_month
                let seasonStartDate = new Date(start_month+"-"+start_date+"-"+startDate.getFullYear());
                let seasonEndDate = new Date(end_month+"-"+end_date+"-"+startDate.getFullYear()+1);
                if (end_month<start_month){
                    seasonEndDate = new Date(end_month+"-"+end_date+"-"+startDate.getFullYear()+1);
                }else{
                    seasonEndDate = new Date(end_month+"-"+end_date+"-"+startDate.getFullYear());
                }
                if (((startDate >= seasonStartDate && startDate <= seasonEndDate))|| (endDate >= seasonStartDate && endDate <= seasonEndDate)) {
                    on_season = true
                    break;
                }
            }

            let price = 0
                price = on_season?parseInt(selected_price.on_season_price)*parseInt(values.number_of_days):parseInt(selected_price.price)*parseInt(values.number_of_days)

            let data = {}
            data['days'] = values.number_of_days
            data['pick_up_location'] = selectedLocation.value
            data["itinerary"] = itinerary.id
            data["vehicle"] = selectedVehicle.value
            data["packege"] = selected_price.id
            data["margin_price"] = price

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json','Authorization': `Bearer ${this.obj.access}`  },
            body: JSON.stringify(data)
            };
            fetch(`${BaseUrl}/api/itineraries/itinerary-vehicles/`,requestOptions)
                  .then(res => 
                      {if(res.status >= 400){
                          res.json()
                          .then(
                              (data) =>{  
                                  console.log(data, "-error")
                                toastr.error("Something Went Wrong", "") 
                                this.setState({ loading: false })
                              }
                                
                          )
                      }
                      else{
                          res.json()
                          .then(
                                (data) =>{
                                toastr.success(`${data.vehicle.name} Added Successfully`, "")
                                this.setState({ model_addVehicle : false })
                                this.loadItineraryVehicles()
                              }
                          )
                      }    
                  }
              )
        }
    }

    render() {
        const {itineraryVehicles, selected_vehicle, selectedVehicleType } = this.state
        const Vehiclecolumns = [
            {
                dataField: "id",
                text: "id",
                hidden: true,
                sort: true,
            },
            
            {
                dataField: "vehicle",
                text: "Name",
                editable: false,
                headerStyle: { backgroundColor: '#fcb92c' },
                formatter: (cellContent, row) => {
                    return (
                        <Link to={`/vehicle/${row?.vehicle.id}`} target="_blank" className="text-dark me-2">{row?.vehicle.name}</Link>
                    )
                } 
            },
            {
                dataField: "brand",
                text: "Brand",
                editable: false,
                headerStyle: { backgroundColor: '#fcb92c' },
                formatter: (cellContent, row) => (
                    row?.vehicle?.brand       
                )    
            },
            {
                dataField: "vehicle_type",
                text: "Type",
                editable: false,  
                headerStyle: { backgroundColor: '#fcb92c' }, 
                formatter: (cellContent, row) => (
                    row?.vehicle?.vehicle_type?.name     
                )   
            },
            {
                dataField: "pick_up_location",
                text: "Pick up Location",
                editable: false,  
                headerStyle: { backgroundColor: '#fcb92c' }, 
                formatter: (cellContent, row) => (
                    row?.pick_up_location?.name
                )   
            },
            {
                dataField: "days",
                text: "Duration",
                editable: false, 
                headerStyle: { backgroundColor: '#fcb92c' },  
                formatter: (cellContent, row) => (
                    this.isInclude(row.vehicle.name+" "+row.vehicle.vehicle_type.name, ["bus", 'volvo'])?
                    '1 Day' : `${row.days} Days` 
                ),
                align: () => {
                    return 'center';    
                }  
            },
            {
                dataField: "margin_price",
                text: "Total Price",
                editable: false,
                headerStyle: { backgroundColor: '#fcb92c' },
                formatter: (cellContent, row) => (
                    "₹ "+row.margin_price      
                ),
                align: () => {
                    return 'right';    
                }     
            },

            {
                dataField: "menu",
                isDummyField: true,
                text: "Action",
                editable: false,
                headerStyle: { backgroundColor: '#fcb92c', width:"10%" },
                formatter: (cellContent, row, col) => 
                { 
                    return (
                        <React.Fragment>
                            <div style={{textAlign:"center"}}>
                                <Link to="#" onClick={() => this.handleVehicleEdit(row)} className="text-secondry me-2"><i className="mdi mdi-lead-pencil font-size-18"></i></Link>
                                <Link to="#" onClick={() => this.setState({ vehicle_id: row.id, vehicle_alert_confirm:true  })} className="text-danger"><i className="mdi mdi-trash-can font-size-18"></i></Link> 
                            </div>
                        </React.Fragment>
                      )
          
                }
              },

            ];
        const VehiclecolumnsnotEdit = [
            {
                dataField: "id",
                text: "id",
                hidden: true,
                sort: true,
            },
            
            {
                dataField: "vehicle",
                text: "Name",
                editable: false,
                headerStyle: { backgroundColor: '#fcb92c' },
                formatter: (cellContent, row) => {
                    return (
                        <Link to={`/vehicle/${row.vehicle.id}`} target="_blank" className="text-dark me-2">{row.vehicle.name}</Link>
                    )
                } 
            },
            {
                dataField: "brand",
                text: "Brand",
                editable: false,
                headerStyle: { backgroundColor: '#fcb92c' },
                formatter: (cellContent, row) => (
                    row.vehicle.brand       
                )    
            },
            {
                dataField: "vehicle_type",
                text: "Type",
                editable: false,  
                headerStyle: { backgroundColor: '#fcb92c' }, 
                formatter: (cellContent, row) => (
                    row.vehicle.vehicle_type.name     
                )   
            },
            {
                dataField: "pick_up_location",
                text: "Pick up Location",
                editable: false,  
                headerStyle: { backgroundColor: '#fcb92c' }, 
                formatter: (cellContent, row) => (
                    row.pick_up_location.name  
                )   
            },
            {
                dataField: "days",
                text: "No of Days",
                editable: false, 
                headerStyle: { backgroundColor: '#fcb92c' },  
            },
            {
                dataField: "margin_price",
                text: "Total Price",
                editable: false,
                headerStyle: { backgroundColor: '#fcb92c' },
                formatter: (cellContent, row) => (
                    "₹ "+row.margin_price      
                ),
                align: () => {
                    return 'right';    
                }      
            },
            ];
        return (
            <React.Fragment key={"vehicle-Detail"}>
                
                <Row>
                    <Col xs={12}>
                        <Card>
                            {!["tour completed"].includes(this.state.itinerary.status) && this.props.user.role !== 1?
                                <CardBody>
                                    <div className="table-responsive">
                                    <BootstrapTable
                                        keyField="id"
                                        data={itineraryVehicles}
                                        columns={Vehiclecolumns}
                                        cellEdit={ cellEditFactory({ mode: 'click', blurToSave: true }) }
                                    />
                                    </div>
                                    <div style={{textAlign: "center"}}>
                                        <Button color="secondary" outline className="waves-effect me-1 mb-3 "  onClick={this.tog_addVehicle}>
                                            Assign New Vehicle
                                        </Button>
                                    </div>
                                </CardBody>
                            :
                                <CardBody>
                                    <div className="table-responsive">
                                    <BootstrapTable
                                        keyField="id"
                                        data={itineraryVehicles}
                                        columns={VehiclecolumnsnotEdit}
                                    />
                                    </div>
                                </CardBody>
                            }
                        </Card>
                    </Col>
                </Row>
                {/* Model Add Vehicle detail */}
                <Col sm={6} md={4} xl={3} className="mt-4">
               
                    <Modal
                    isOpen={this.state.model_addVehicle}
                    toggle={this.tog_addVehicle}
                    centered={true}
                    >
                        <ModalHeader toggle={this.tog_addVehicle}>
                        Assign Vehicle
                        </ModalHeader>
                        <ModalBody>
                            <AvForm className="needs-validation" onValidSubmit={this.handleSaveVehicle} >

                                <Row>
                                    <Col md="6">
                                        <div className="mb-3">
                                            <Label className="form-label">Pickup Destination</Label>
                                            <Select 
                                                // onInputChange ={this.onDestinationInputChange}
                                                value={this.state.selectedDestination}
                                                onChange={this.handleSelectedDestination}
                                                options={this.state.DestinationGroup}
                                                classNamePrefix="select2-selection"
                                            />
                                        </div>
                                    </Col>
                                    <Col md="6">
                                        <div className="mb-3">
                                            <Label className="form-label">Pickup Location</Label>
                                            <Select 
                                                onInputChange = {this.onInputChange}
                                                value = {this.state.selectedLocation}
                                                onChange={this.handleSelectLocationGroup}
                                                options={this.state.VehicleLocationsGroup}
                                                classNamePrefix="select2-selection"
                                            />
                                        </div>
                                    </Col>
                                </Row>
                    
                                <Row>
                                    
                                    <Col md="6">
                                        <div className="mb-3">
                                            <Label className="form-label">Vehicle Type</Label>
                                            <Select
                                                value = {selectedVehicleType}
                                                onChange= {this.handleselectedVehicleType}
                                                options={this.state.VehicleTypeGroup}
                                                classNamePrefix="select2-selection"
                                            />
                                        </div>
                                    </Col> 
                                    <Col md="6">
                                        <div className="mb-3">
                                            <Label className="form-label">Vehicle</Label>
                                            <Select 
                                                onInputChange={this.onVehicleInputChange}
                                                value = {this.state.selectedVehicle}
                                                onChange= {this.handleselectedVehicle}
                                                options={this.state.vehiclesGroup}
                                                classNamePrefix="select2-selection"
                                            />
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="12">
                                        <div className="mb-3">
                                            <Label className="form-label">Pricing Package</Label>
                                            <Select 
                                                value = {this.state.SelectedDuration}
                                                onChange= {this.handleselectedDuration}
                                                options={this.state.VehicleDurationGroup}
                                                classNamePrefix="select2-selection"
                                            />
                                        </div>
                                    </Col>
                                </Row>
                                {selectedVehicleType && ["bus"].includes((selectedVehicleType.label).toLowerCase())?
                                <Row>
                                    <Col md={6}>
                                        <div className="mb-3">
                                            <AvField
                                                name="number_of_days"
                                                label="Number of PAX"
                                                placeholder="Number of PAX"
                                                type="number"
                                                errorMessage="Enter Number of PAX"
                                                validate={{ 
                                                    required: { value: true },
                                                    pattern: {
                                                    value: "[0-9]",
                                                    errorMessage: "Only Digits"
                                                    }
                                                }}
                                                />
                                        </div>
                                    </Col>
                                </Row>
                                :
                                <Row>
                                <Col md={6}>
                                    <div className="mb-3">
                                        <AvField
                                            name="number_of_days"
                                            label="Number of Day"
                                            placeholder="Number of Days"
                                            type="number"
                                            errorMessage="Enter Number of Days"
                                            validate={{ 
                                                required: { value: true },
                                                pattern: {
                                                value: "[0-9]",
                                                errorMessage: "Only Digits"
                                                }
                                            }}
                                            />
                                    </div>
                                </Col>
                            </Row>}
                             
                                                       
                                <FormGroup className="mb-0">
                                {this.state.addVehicleloading?(
                                    <Spinner className="me-2 mt-2" color="primary" />
                                ):(
                                    <div>
                                
                                <Button type="submit" color="primary" className="me-1">
                                    Submit
                                </Button>
                                </div>
                                    )}
                                </FormGroup>     
                            </AvForm>

                        </ModalBody>
                    </Modal>
                </Col>
                
                {/* Model Edit Vehicle detail */}
                <Col sm={6} md={4} xl={3} className="mt-4">
               
                    <Modal
                    isOpen={this.state.model_editVehicle}
                    toggle={this.tog_editVehicle}
                    centered={true}
                    >
                        <ModalHeader toggle={() => this.tog_editVehicle()}>
                        Edit {selected_vehicle.vehicle?selected_vehicle.vehicle.name:""} Vehicle
                        </ModalHeader>
                        <ModalBody>
                            <AvForm className="needs-validation" onValidSubmit={this.handleEditVehicleSubmit} >
                            <Row>
                                    <Col md="6">
                                        <div className="mb-3">
                                            <Label className="form-label">Pickup Destination</Label>
                                            <Select 
                                                // onInputChange ={this.onDestinationInputChange}
                                                value={this.state.selectedDestination}
                                                onChange={this.handleSelectedDestination}
                                                options={this.state.DestinationGroup}
                                                classNamePrefix="select2-selection"
                                            />
                                        </div>
                                    </Col>
                                    <Col md="6">
                                        <div className="mb-3">
                                            <Label className="form-label">Pickup Location</Label>
                                            <Select 
                                                onInputChange = {this.onInputChange}
                                                value = {this.state.selectedLocation}
                                                onChange={this.handleSelectLocationGroup}
                                                options={this.state.VehicleLocationsGroup}
                                                classNamePrefix="select2-selection"
                                            />
                                        </div>
                                    </Col>
                                </Row>
                    
                                <Row>
                                    
                                    <Col md="6">
                                        <div className="mb-3">
                                            <Label className="form-label">Vehicle Type</Label>
                                            <Select
                                                value = {this.state.selectedVehicleType}
                                                onChange= {this.handleselectedVehicleType}
                                                options={this.state.VehicleTypeGroup}
                                                classNamePrefix="select2-selection"
                                            />
                                        </div>
                                    </Col> 
                                    <Col md="6">
                                        <div className="mb-3">
                                            <Label className="form-label">Vehicle</Label>
                                            <Select 
                                                onInputChange={this.onVehicleInputChange}
                                                value = {this.state.selectedVehicle}
                                                onChange= {this.handleselectedVehicle}
                                                options={this.state.vehiclesGroup}
                                                classNamePrefix="select2-selection"
                                            />
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="12">
                                        <div className="mb-3">
                                            <Label className="form-label">Pricing Package</Label>
                                            <Select 
                                                value = {this.state.SelectedDuration}
                                                onChange= {this.handleselectedDuration}
                                                options={this.state.VehicleDurationGroup}
                                                classNamePrefix="select2-selection"
                                            />
                                        </div>
                                    </Col>
                                </Row>
                                {selectedVehicleType && ["bus"].includes((selectedVehicleType.label).toLowerCase())?
                                <Row>
                                    <Col md={6}>
                                        <div className="mb-3">
                                            <AvField
                                                name="number_of_days"
                                                label="Number of PAX"
                                                placeholder="Number of PAX"
                                                type="number"
                                                value={selected_vehicle.days}
                                                errorMessage="Enter Number of PAX"
                                                validate={{ 
                                                    required: { value: true },
                                                    pattern: {
                                                    value: "[0-9]",
                                                    errorMessage: "Only Digits"
                                                    }
                                                }}
                                                />
                                        </div>
                                    </Col>
                                </Row>
                                :
                                <Row>
                                <Col md={6}>
                                    <div className="mb-3">
                                        <AvField
                                            name="number_of_days"
                                            label="Number of Day"
                                            placeholder="Number of Days"
                                            type="number"
                                            errorMessage="Enter Number of Days"
                                            value={selected_vehicle.days}
                                            validate={{ 
                                                required: { value: true },
                                                pattern: {
                                                value: "[0-9]",
                                                errorMessage: "Only Digits"
                                                }
                                            }}
                                            />
                                    </div>
                                </Col>
                            </Row>}
                                <FormGroup className="mb-0">
                                {this.state.editVehicleloading?(
                                    <Spinner className="me-2 mt-2" color="primary" />
                                ):(
                                    <div>
                                
                                <Button type="submit" color="primary" className="me-1">
                                    Update
                                </Button>
                                </div>
                                    )}
                                </FormGroup>     
                            </AvForm>

                        </ModalBody>
                    </Modal>
                </Col>
                {this.state.vehicle_alert_confirm ? (
                    <SweetAlert
                    title="Are you sure?"
                    warning
                    showCancel
                    confirmBtnBsStyle="success"
                    cancelBtnBsStyle="danger"
                    onConfirm={() => this.handleVehicleDelete(this.state.vehicle_id)}
                    onCancel={() =>
                        this.setState({
                            vehicle_alert_confirm: false,
                            vehicle_id:"",
                        })
                    }
                    >
                    You won't be able to revert this!
                    </SweetAlert>
                    ) : null}

                {this.state.vehicle_success_confirm ? (
                <SweetAlert
                success
                title={this.state.dynamic_title}
                confirmBtnBsStyle="success"
                cancelBtnBsStyle="danger"
                onConfirm={() => this.setState({ vehicle_success_confirm: false, vehicle_alert_confirm : false })}
                >
                    {this.state.dynamic_description}
                </SweetAlert>
                ) : null
              }
                    
            </React.Fragment>
            
        );
    }
}

export default VehicleDetail;